module.exports = __webpack_public_path__ + "static/media/uploadError.1e8bd276.svg";